import React from 'react';
import { Link } from 'react-router-dom';  

/** Bootstrap Components */
import { Card,Col, Button } from 'react-bootstrap';  

/** React Icons */
import { FaArrowCircleRight,FaLock } from "react-icons/fa";
import { MdDriveFileRenameOutline,MdFileUpload,MdAddTask,MdHome, MdLogout } from "react-icons/md";

import Offcanvas from 'react-bootstrap/Offcanvas';
import { PASSWD_DAYS } from '../utils/constants';

/** Custom CSS */
import '../css/styles.css';  


class SideMenuComponent extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			show : false
		}
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);
	}

	handleClose(){
		this.setState({'show': false})
	}

	handleOpen(){
		this.setState({'show': true})
	}

	render() {
		return (
			<div>
				<div className='mobile'>
					<div className='p-2'>
						<Button onClick={this.handleOpen}>MENU</Button>
					</div>
					<Offcanvas show={this.state.show} onHide={this.handleClose}>
						<Offcanvas.Header closeButton style={{backgroundColor:"#3998ac"}}>
								<Offcanvas.Title></Offcanvas.Title>
						</Offcanvas.Header>
						<Offcanvas.Body className='font-custom link'>
							<SideText/>
					</Offcanvas.Body>
						<div className='canvasfooter'>&nbsp;</div>
					</Offcanvas>
				</div>

				<div className='nomobile'>
					<SideText/>
				</div>
			</div>
	)
}
}
export default SideMenuComponent

class SideText extends React.Component{
	
	onLogout = () =>{
		sessionStorage.clear();
		localStorage.clear();
		this.props.history("/login");
	}

	render(){
		if(sessionStorage.getItem('days') < PASSWD_DAYS){
			return (<>
					<Link to='/home'>
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdHome/>
											<span className='mx-2 my-2 link-title'>Home</span>
										</Col>
										<Col className='col-1'><FaArrowCircleRight/></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>						
					<Link to='/documentlist' >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdDriveFileRenameOutline/>
											<span className='mx-2 my-2 link-title'>Uploaded Document</span>
										</Col>
										<Col className='col-1'>
											<FaArrowCircleRight/>
										</Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>						
					<Link to='/uploaddfg' >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdFileUpload/>
											<span className='mx-2 my-2 link-title'>Demands for Grants</span>
										</Col>
										<Col className='col-1'><FaArrowCircleRight/></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>						
					<Link to='/uploadreviseddfg' >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdFileUpload/>
											<span className='mx-2 my-2 link-title'>Revised Demands for Grants</span>
										</Col>
										<Col className='col-1'><FaArrowCircleRight/></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>						
					<Link to='/addmenu' >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdAddTask/>
											<span className='mx-2 my-2 link-title'>Menu Upload</span>
										</Col>
										<Col className='col-1'><FaArrowCircleRight/></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>						
					<Link to='/changepwd' >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<FaLock/>
											<span className='mx-2 my-2 link-title'>Change Password</span>
										</Col>
										<Col className='col-1'><FaArrowCircleRight/></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>
					<Link to='/login' onClick={this.onLogout} >
						<Card className='link-card'>
							<Card.Body>
								<Card.Title>
									<h6 className="row">
										<Col className='col-11'>
											<MdLogout/>
											<span className='mx-2 my-2 link-title'>Logout</span>
										</Col>
										<Col className='col-1'></Col>
									</h6>
								</Card.Title>
							</Card.Body>
						</Card>
					</Link>
				</>)
		}
		else{
			return( 
				<>
				<Link to='/home'>
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<MdHome/>
									<span className='mx-2 my-2 link-title'>Home</span>
								</Col>
								<Col className='col-1'><FaArrowCircleRight/></Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>						
			<Link to='/home' >
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<MdDriveFileRenameOutline/>
									<span className='mx-2 my-2 link-title'>Uploaded Document</span>
								</Col>
								<Col className='col-1'>
									<FaArrowCircleRight/>
								</Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>						
			<Link to='/home' >
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<MdFileUpload/>
									<span className='mx-2 my-2 link-title'>Demands for Grants</span>
								</Col>
								<Col className='col-1'><FaArrowCircleRight/></Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>						
			<Link to='/home' >
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<MdAddTask/>
									<span className='mx-2 my-2 link-title'>Menu Upload</span>
								</Col>
								<Col className='col-1'><FaArrowCircleRight/></Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>						
			<Link to='/home' >
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<FaLock/>
									<span className='mx-2 my-2 link-title'>Change Password</span>
								</Col>
								<Col className='col-1'><FaArrowCircleRight/></Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>
			<Link to='/login' onClick={this.onLogout} >
				<Card className='link-card'>
					<Card.Body>
						<Card.Title>
							<h6 className="row">
								<Col className='col-11'>
									<MdLogout/>
									<span className='mx-2 my-2 link-title'>Logout</span>
								</Col>
								<Col className='col-1'></Col>
							</h6>
						</Card.Title>
					</Card.Body>
				</Card>
			</Link>
		</>)	
	}
}
}